/* External dependencies */
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-west-2_Vks7GkhlO',
      userPoolClientId: '7nm1627efll9vkbn9dnqhimp4g',
      identityPoolId: 'us-west-2:bef27d80-b3fd-4bb5-b586-97238d37f96e',
      loginWith: {
        oauth: {
          domain: 'beta-finik-maps.auth.us-west-2.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            'https://www.beta.zhekshenbekukumar.mancho.school/web-app/',
          ],
          redirectSignOut: [
            'https://www.beta.zhekshenbekukumar.mancho.school/web-app/',
          ],
          responseType: 'code',
          providers: ['Google'],
        },
      },
    },
  },
});
